var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddressDetails(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9738 1H5.02457C3.14783 1 1.62109 2.52674 1.62109 4.40421V11.5958C1.62109 13.4725 3.14783 15 5.02457 15H10.9738C12.8506 15 14.378 13.4725 14.378 11.5958V4.40421C14.378 2.52674 12.8506 1 10.9738 1Z",
    fill: "#484848",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4371 6.41093H5.55849C5.25344 6.41093 5.00586 6.16335 5.00586 5.8583C5.00586 5.55324 5.25344 5.30566 5.55849 5.30566H10.4371C10.7422 5.30566 10.9897 5.55324 10.9897 5.8583C10.9897 6.16335 10.7422 6.41093 10.4371 6.41093ZM7.84858 9.88149H5.55849C5.25344 9.88149 5.00586 9.63391 5.00586 9.32886C5.00586 9.02381 5.25344 8.77623 5.55849 8.77623H7.84858C8.15363 8.77623 8.40121 9.02381 8.40121 9.32886C8.40121 9.63391 8.15363 9.88149 7.84858 9.88149Z",
    fill: "#484848"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressDetails);
export default __webpack_public_path__ + "static/media/address_details.bed41bccb218fbe72a31684a6fa99785.svg";
export { ForwardRef as ReactComponent };